import SigniteButton from '../../ui-elements/signite-button/signiteButton';
import CandidateInfoNav from './candiate-info-nav/candiateInfoNav';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import CandidatePersonalInfoForm from './candidate-forms/personal-details/candiatePersonalDetails';
import { Route, Routes, useLocation, useParams } from 'react-router-dom';
import CandidateWorkExperienceForm from './candidate-forms/work-experience/candidateWorkExperience';
import CandidateEducationDetailsForm from './candidate-forms/education-details/educationDetails';
import CandidateCompensationForm from './candidate-forms/compensation-details/candidateCompensationDetails';
import CandidateValueAddsForm from './candidate-forms/value-adds/valueAdds';
import { useEffect, useRef } from 'react';
import { submit } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { CandidateService } from '../../../services/candidateService';
import { transformPersonalInformation } from './transformers/cadiateDataTransformer';
import { addCandidate } from '../../../redux/slices/personalDetailSlice';
import { addEducationDetails } from '../../../redux/slices/educationalQualificationSlice';
import { transformEducationDetails } from './transformers/educationDetailsTransformer';
import { transformValueAddData } from './transformers/valueAddTransformer';
import { transformWorkExperienceDetails } from './transformers/workExperienceTransformer';
import { transformCompensationDetails } from './transformers/compensationDetailsTransformer';
import { addWorkExperience } from '../../../redux/slices/WorkExperienceSlice';
import { useState } from 'react';
import Loader from 'react-spinner-loader';
import { addValueAdds } from '../../../redux/slices/valueAddsSlice';
import { addCompensationDetails } from '../../../redux/slices/compensationDetailsSlice';
import UnloadWarning from '../unload-warning/unloadWarning';
import CandidateCuratedClients from './candiate-info-nav/candidateCuratedClients';

const CandidateDataForm = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const candidateId = useSelector((state) => state.personalDetails && state.personalDetails.candidateId);
  const personalDetails = useSelector((state) => state.personalDetails && state.personalDetails.candidate);
  const educationDetails = useSelector((state) => state.educationDetails);
  const workExperienceDetails = useSelector((state) => state.workExperience);
  const compensationData = useSelector((state) => state.compensationDetails);
  const valueAddDetails = useSelector((state) => state.valueAddDetails);
  const fileUploads = useSelector((state) => state.fileUploads);
  const [loader, setLoader] = useState(false);
  let currentForm = '';
  const formRef = useRef();
  const eduFormRef = useRef();
  const compensationRef = useRef();
  const workExperienceFormRef = useRef();
  const valueAddFormRef = useRef();
  useEffect(() => {
    if (location.pathname.startsWith('/candidate')) {
      const referrer = document.referrer;
      const fromStorage = sessionStorage.getItem('prevNonCandidatePath');
      if (!fromStorage) {
        try {
          const refPath = new URL(referrer).pathname;
          if (!refPath.startsWith('/candidate')) {
            sessionStorage.setItem('prevNonCandidatePath', refPath);
          }
        } catch {
          sessionStorage.setItem('prevNonCandidatePath', '/');
        }
      }
    }
  }, []);



  const formMap = {
    '/candidate/candidate-personal-info': 'personal-details',
    '/candidate/candidate-work-experience': 'work-experience',
    '/candidate/candidate-education-details': 'educational-details',
    '/candidate/candidate-compensation-details': 'compensation-details',
    '/candidate/candidate-value-adds': 'value-adds',
  };
  useEffect(() => {
    currentForm = formMap[location.pathname];
  }, [location.pathname]);

  const formData = {};
  const saveCurrentValues = async (data) => {
    currentForm = formMap[location.pathname];
    formData[currentForm] = data;
  };
  const saveForm = async () => {
    const form = currentForm;
    const data = formData[form];
    try {
      currentForm = form;
      setLoader(true);
      switch (currentForm) {
        case 'personal-details': {
          // const transformedData = transformPersonalInformation(data, fileUploads && fileUploads.dp);
          // const transformedData = transformPersonalInformation(data, (_.get(fileUploads, "dp", []).length > 0 ? fileUploads.dp : null) || _.get(fileUploads, "dp", []).length == 0 ? data.displayPic : null);
          // Remove fallback to data.displayPic
          const hasDp = _.has(fileUploads, "dp");
          const dpUpload = hasDp ? (fileUploads.dp.length > 0 ? fileUploads.dp : null) : data.displayPic;

          const transformedData = transformPersonalInformation(data, dpUpload);

          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedData,
            };
            response = await CandidateService.saveCandidate(dataForUpdate, 'pd').catch(handleServiceException);
          } else {
            response = await CandidateService.addCandidate(transformedData).catch(handleServiceException);
          }

          if (response && response.status === 200) {
            dispatch(addCandidate(response.data));
            alert('Personal Details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

          }

          break;
        }
        case 'work-experience': {
          const transformedWorkExperienceDetails = transformWorkExperienceDetails(data);

          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedWorkExperienceDetails,
            };
            response = await CandidateService.saveCandidate(dataForUpdate, 'we').catch(handleServiceException);
          }

          if (response && response.status === 200) {
            alert('Work Experience saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addWorkExperience(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
        case 'educational-details': {
          let transformedEducationDetails = {};
          try {
            transformedEducationDetails = transformEducationDetails(data);
          } catch (e) {
            console.error(e);
          }

          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedEducationDetails,
            };
            response = await CandidateService.saveCandidate(dataForUpdate, 'ed').catch(handleServiceException);
          }
          if (response && response.status === 200) {
            alert('Education Details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addEducationDetails(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
        case 'compensation-details': {
          const transformedCompensationDetails = transformCompensationDetails(data);
          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedCompensationDetails,
            };
            response = await CandidateService.saveCandidate(dataForUpdate, 'cd').catch(handleServiceException);
          }

          if (response && response.status === 200) {
            alert('Compensation Details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addCompensationDetails(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
        case 'value-adds': {
          let transformedValueAddDetails = null;
          try {
            transformedValueAddDetails = transformValueAddData(data);
          } catch (e) {
            console.log(e);
          }
          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedValueAddDetails,
            };
            response = await CandidateService.saveCandidate(dataForUpdate, 'va').catch(handleServiceException);
          }

          if (response && response.status === 200) {
            alert('Value Add details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addValueAdds(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
      }
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoader(false);
    }
  };
  const submitForm = () => {
    currentForm = formMap[location.pathname];
    switch (currentForm) {
      case 'personal-details':
        formRef.current.handleSubmit();
        break;
      case 'educational-details':
        eduFormRef.current.handleSubmit();
        break;
      case 'work-experience':
        workExperienceFormRef.current.handleSubmit();
        break;
      case 'compensation-details':
        compensationRef.current.handleSubmit();
        break;
      case 'value-adds':
        valueAddFormRef.current.handleSubmit();
        break;
    }
  };

  const handleServiceException = (err) => {
    if (!err.response) {
      alert('Error: Network Error!');
    } else {
      const errors = err.response.data.fieldViolations;
      if (errors) {
        const errorMessages = Object.entries(errors)
          .map(([field, message]) => `${field.replace(/candidate\.personalDetails\./, '')} ${message}`)
          .join('\n');
        alert(`Error saving ${currentForm} :\n${errorMessages}`);
      } else {
        alert(`Error saving ${currentForm} : ${err.response.data.message || 'An unknown error occurred.'}`);
      }
    }
  };
  const handleSubmit = async (data, form) => {
    try {
      currentForm = form;
      setLoader(true);
      switch (currentForm) {
        case 'personal-details': {
          const hasDp = _.has(fileUploads, "dp");
          const dpUpload = hasDp ? (fileUploads.dp.length > 0 ? fileUploads.dp : null) : data.displayPic;

          const transformedData = transformPersonalInformation(data, dpUpload);
          // const transformedData = transformPersonalInformation(data, (_.get(fileUploads, "dp", []).length > 0 ? fileUploads.dp : null) || _.get(fileUploads, "dp", []).length == 0 ? data.displayPic : null);
          // const transformedData = transformPersonalInformation(data, fileUploads && fileUploads.dp);

          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,

              ...transformedData,
            };
            response = await CandidateService.updateCandidate(dataForUpdate, 'pd').catch(handleServiceException);
          } else {
            response = await CandidateService.addCandidate(transformedData).catch(handleServiceException);
          }

          if (response && response.status === 200) {
            dispatch(addCandidate(response.data));
            alert('Personal Details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

          }

          break;
        }
        case 'work-experience': {
          const transformedWorkExperienceDetails = transformWorkExperienceDetails(data);

          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedWorkExperienceDetails,
            };
            response = await CandidateService.updateCandidate(dataForUpdate, 'we').catch(handleServiceException);
          }

          if (response && response.status === 200) {
            alert('Work Experience saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addWorkExperience(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
        case 'educational-details': {
          let transformedEducationDetails = {};
          try {
            transformedEducationDetails = transformEducationDetails(data);
          } catch (e) {
            console.error(e);
          }
          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedEducationDetails,
            };
            response = await CandidateService.updateCandidate(dataForUpdate, 'ed').catch(handleServiceException);
          }
          if (response && response.status === 200) {
            alert('Education Details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addEducationDetails(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
        case 'compensation-details': {
          const transformedCompensationDetails = transformCompensationDetails(data);
          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedCompensationDetails,
            };
            response = await CandidateService.updateCandidate(dataForUpdate, 'cd').catch(handleServiceException);
          }

          if (response && response.status === 200) {
            alert('Compensation Details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addCompensationDetails(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
        case 'value-adds': {
          let transformedValueAddDetails = null;
          try {
            transformedValueAddDetails = transformValueAddData(data);
          } catch (e) {
            console.log(e);
          }
          let response = null;
          if (personalDetails && candidateId) {
            const dataForUpdate = {
              candidateId: candidateId,
              ...transformedValueAddDetails,
            };
            response = await CandidateService.updateCandidate(dataForUpdate, 'va').catch(handleServiceException);
          }

          if (response && response.status === 200) {
            alert('Value Add details saved successfully!');
            sessionStorage.setItem('candidateUpdated', 'true');

            dispatch(addValueAdds(response.data));
            dispatch(addCandidate(response.data));
          }

          break;
        }
      }
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Container fluid>
      <UnloadWarning />
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
      <Row>
        <Col>
          <CandidateInfoNav />
        </Col>
      </Row>
      {!location.pathname.includes('candidate-curated-clients') && (
        <Row>
          <Col>
            <SigniteButton
              className="float-end"
              variant="outline-primary"
              style={{ marginTop: 24, marginBottom: 24, marginLeft: 16, width: 183 }}
              onClick={submitForm}
            >
              Submit
            </SigniteButton>
            <SigniteButton
              className="float-end"
              variant="outline-primary"
              style={{ marginTop: 24, marginBottom: 24, marginLeft: 16, width: 183 }}
              onClick={saveForm}
            >
              Save
            </SigniteButton>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <Routes>
            <Route
              path="candidate-personal-info"
              element={
                <CandidatePersonalInfoForm
                  onSubmit={handleSubmit}
                  saveCurrentValues={saveCurrentValues}
                  componentRef={formRef}
                  personalDetails={personalDetails}
                />
              }
            ></Route>
            <Route
              path="candidate-work-experience"
              element={
                <CandidateWorkExperienceForm
                  onSubmit={handleSubmit}
                  saveCurrentValues={saveCurrentValues}
                  componentRef={workExperienceFormRef}
                  workExperience={workExperienceDetails.candidate}
                />
              }
            ></Route>
            <Route
              path="candidate-education-details"
              element={
                <CandidateEducationDetailsForm
                  onSubmit={handleSubmit}
                  saveCurrentValues={saveCurrentValues}
                  componentRef={eduFormRef}
                  educationDetails={educationDetails && educationDetails.candidate}
                />
              }
            ></Route>
            <Route
              path="candidate-compensation-details"
              element={
                <CandidateCompensationForm
                  onSubmit={handleSubmit}
                  saveCurrentValues={saveCurrentValues}
                  componentRef={compensationRef}
                  candidateData={compensationData && compensationData.candidate}
                />
              }
            ></Route>
            <Route
              path="candidate-value-adds"
              element={
                <CandidateValueAddsForm
                  onSubmit={handleSubmit}
                  saveCurrentValues={saveCurrentValues}
                  componentRef={valueAddFormRef}
                  valueAddData={valueAddDetails && valueAddDetails.candidate}
                />
              }
            ></Route>
            <Route
              path="candidate-curated-clients"
              element={<CandidateCuratedClients />}
            />
          </Routes>
        </Col>
      </Row>

      {!location.pathname.includes('candidate-curated-clients') && (
        <Row>
          <Col>
            <hr style={{ marginTop: 32, marginBottom: 32 }} />
            <SigniteButton
              className="float-end"
              variant="outline-primary"
              style={{
                marginTop: 24,
                marginBottom: 24,
                marginLeft: 16,
                width: 183,
              }}
              onClick={submitForm}
            >
              Submit
            </SigniteButton>
            <SigniteButton
              className="float-end"
              variant="outline-primary"
              style={{
                marginTop: 24,
                marginBottom: 24,
                marginLeft: 16,
                width: 183,
              }}
              onClick={saveForm}
            >
              Save
            </SigniteButton>
          </Col>
        </Row>
      )}
    </Container>
  );
};
export default CandidateDataForm;